import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import styles from './styles';

const MfaOtpFields = ({
  code,
  activeCode,
  setActiveCode,
  invalid,
  enableInput,
  timer,
  isCounting,
  handleChange,
  resendOTP,
}) => {
  const theme = useTheme();
  let emailTextFieldStyle = 'input-text';

  if (!code) {
    emailTextFieldStyle += ' text-empty';
  } else if (enableInput) {
    emailTextFieldStyle += ' text-entered';
  } else {
    emailTextFieldStyle += ' text-entered-invalid';
  }

  return (
    <Box>
      <Box sx={styles(theme).bodyContainer}>
        <div className='text-field'>
          <input
            className={emailTextFieldStyle}
            type='text'
            id='verification-code'
            placeholder='Verification code'
            onChange={handleChange}
            value={code}
            disabled={!enableInput}
            onClick={() => setActiveCode(!activeCode)}
          />

          {invalid && (
            <div className='invalid-email-format'>
              Oops! The code you entered is incorrect or may have expired. Please try again.
            </div>
          )}
          <div
            className={`${isCounting ? 'disabled-forgotten-input-text' : 'forgotten-input-text'}`}
            style={{ opacity: '0.7' }}
          >
            {/* eslint-disable-next-line */}
            Didn’t received a code?
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
            <span
              style={{ cursor: 'pointer', color: '#DD1D77', textDecoration: 'underline' }}
              onClick={resendOTP}
            >
              {' '}
              {isCounting ? `Try again ${timer}s` : `Resend SMS`}
            </span>
          </div>
        </div>
      </Box>
    </Box>
  );
};

export default MfaOtpFields;
